import React, { useEffect, useState } from 'react';
import * as echarts from 'echarts';
import { useIntl, getLocale } from 'umi';
import { formatNum } from '@/pages/intelligence/utils/commonUtils';
import ChartBubble from "@/pages/intelligence/components/ChartBubble";

export default function useMobileGameBarChart() {

  const { formatMessage } = useIntl();
  const locale = getLocale();
  const [xAxisDataCur, setXAxisDataCur] = useState([]);
  const [seriesCur, setSeriesCur] = useState([]);

  const dealAnnualReportChartsData = (data: any, year: string) => {

    let xAxisData = [];
    Object.keys(data).map((key) => {
      if (key <= year) {
        xAxisData.push(key);
      }
    });
    xAxisData.sort();
    let mobileData = [];
    let pcData = [];
    let consoleData = [];
    xAxisData.map((item) => {
      let i = data[item];
      mobileData.push(Math.floor(i['mobile_rev'] * 100) / 100);
      pcData.push(Math.floor(i['pc_rev'] * 100) / 100);
      consoleData.push(Math.floor(i['console_rev'] * 100) / 100);
    });

    let series = [
      {
        name: 'Mobile',
        type: 'bar',
        barGap: '20%',
        label: {
          show: true,
          position: 'top',
          formatter: function (params) {
            return formatNum(params.value);
          },
        },
        data: mobileData,
      },
      {
        name: 'PC',
        type: 'bar',
        barGap: '20%',
        label: {
          show: true,
          position: 'top',
          formatter: function (params) {
            return formatNum(params.value);
          },
        },
        data: pcData,
      },
      {
        name: 'Console',
        type: 'bar',
        barGap: '20%',
        label: {
          show: true,
          position: 'top',
          formatter: function (params) {
            return formatNum(params.value);
          },
        },
        data: consoleData,
      },
    ];
    setXAxisDataCur(xAxisData);
    setSeriesCur(series);

    mpBarCharts('mpAnnualSummaryCharts', xAxisData, series);
  };

  useEffect(() => {
    mpBarCharts('mpAnnualSummaryCharts', xAxisDataCur, seriesCur);
  }, [locale]);

  //柱状图
  const mpBarCharts = (containId: string, xAxisData: any, series: any) => {
    let chartDom = document.getElementById(containId);
    if (chartDom) {
      let myChart = echarts.init(chartDom);
      const barFormatterTooltip = (params: any) => {
        const safeNumber = (val: any): number => {
          const num = Number(val);
          return Number.isNaN(num) ? 0 : num;
        };
        let totalNum = safeNumber(params[1]?.value) + safeNumber(params[2]?.value) + safeNumber(params[0]?.value);
        return ChartBubble({
          data: params,
          otherTitleLeft: formatMessage({ id: 'dbi_all' }),
          secondTitleRight: formatMessage({ id: 'dbi_revenue_$' }),
          topChartsType: 'marketProfile-annual-bar',
          imageType: 'mobile',
          chartType: 'line',
          dateType: 'month',
          otherTitleRight: formatNum(Math.floor(totalNum)),
          ifNoBarImg: true,
        })
      }

      let option = {
        color: ['#5086F3', '#5EC8F1', '#69D19C'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            shadowStyle: {
              color: '#0076FF',
              opacity: '0.05',
            },
          },
          padding: 0,
          borderWidth: 0,
          formatter: barFormatterTooltip,
          backgroundColor: 'rgba(0,0,0,0)'
        },
        grid: {
          top: '10%',
          right: '2%',
          width: '95%',
          bottom: 25,
          containLabel: true,
        },
        legend: {
          show: true,
          bottom: 0,
          lineStyle: {
            opacity: 0,
          },
          icon: 'circle',
          type: 'scroll',
          itemWidth: 8,
        },
        toolbox: {
          show: false,
        },
        xAxis: {
          type: 'category',
          axisTick: { show: false },
          data: xAxisData,
        },

        yAxis: {
          type: 'value',
          axisLine: {
            show: false,
          },
          axisLabel: {
            color: '#BBBBBB',
            formatter: function (value, index) {
              return formatNum(value);
            },
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              color: '#E9E9E9',
            },
          },
        },
        series: series,
      };
      option && myChart.setOption(option, true);
      myChart.resize();
    }
  };


  return {
    dealAnnualReportChartsData
  }

}